<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />
    <div id="contact">
      <div v-if="show_contact == true">
        <h2>Have Any Questions?</h2>
        <p>Contact us by filling out the information below</p>

        <v-alert
          v-if="contact_notice != ''"
          class="alert alert-warning"
          type="error"
        >
          There was a problem submitting your message. {{ contact_notice }}.
        </v-alert>

        <form @submit.prevent="sendEmail">
          <div class="form-group text-left">
            <base-text-field
              class="round"
              v-model="name"
              name="name"
              solo
              label="Name"
            />

            <base-text-field
              v-model="email"
              type="email"
              class="round form-control"
              solo
              name="email"
              label="Email"
            />

            <base-text-field
              class="round"
              name="subject"
              solo
              autogrow
              label="Subject"
            />
            <base-textarea
              v-model="message"
              solo
              name="message"
              class="round mb-6"
              rounded
              label="Your Need & Description"
            />
          </div>
          <!-- <base-btn
            type="submit"
            style="background-image: linear-gradient(to top, #cc208e 0%, #6713d2 100%);"
            class=" hero-button white--text "
            rounded
            elevation="8"
            large
          >
            Send message
          </base-btn> -->
          <v-hover>
            <template v-slot="{ hover }">
              <v-btn
                type="submit"
                style="margin-bottom: 120px; hover: transparent"
                :elevation="hover ? 10 : 0"
                color="accent"
                class="mr-4 mt-n4 round black--text appbutton"
                :small="$vuetify.breakpoint.smAndDown"
                :large="$vuetify.breakpoint.lgAndUp"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  :height="$vuetify.breakpoint.mdAndUp ? '25' : '20'"
                  :width="$vuetify.breakpoint.mdAndUp ? '25' : '20'"
                  data-prefix="fat"
                  data-icon="paper-plane"
                  class="svg-inline--fa fa-paper-plane fa-w-16"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="white"
                    d="M498.1 5.629C492.7 1.891 486.4 0 480 0c-5.461 0-10.94 1.399-15.88 4.223l-448 255.1C5.531 266.3-.6875 277.8 .0625 289.1s8.375 22.86 19.62 27.55l103.2 43.01l61.85 146.5c.793 1.881 2.155 3.488 4.097 4.314C189.9 511.8 190.9 512 191.1 512c2.031 0 4.024-.7715 5.555-2.24l85.75-82.4l120.4 50.16c3.969 1.656 8.1 2.472 12.29 2.472c5.406 0 10.84-1.378 15.68-4.097c8.594-4.828 14.47-13.31 15.97-23.05l64-415.1C513.5 24.72 508.3 12.58 498.1 5.629zM16.03 289C15.65 282.9 18.73 277.2 24.06 274.1l448-256c.834-.4766 1.838-.4102 2.736-.7285L124.8 344l-99-41.25C20.25 300.4 16.4 295 16.03 289zM411.5 98.33l-225.7 280.7C184.6 380.4 184 382.2 184 384v80.38l-46.45-110.3L411.5 98.33zM200 485.2v-92.55l67.19 27.99L200 485.2zM431.8 450.4c-.7559 4.902-3.668 9.105-7.988 11.53C421.4 463.3 418.7 464 416 464c-2.117 0-4.188-.416-6.158-1.238l-202.9-84.55l285.6-355.1c2.357 3.338 3.885 7.193 3.244 11.34L431.8 450.4z"
                  ></path>
                </svg>
                <span class="b ml-2 white--text">Send</span>
              </v-btn>
            </template>
          </v-hover>
        </form>
      </div>

      <div v-else>
        <h3>Message Sent Successfully!</h3>
        <p>
          Thank you for contacting us, we'll get back to you as soon as we can.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { functions } from "../../main";
import emailjs from "emailjs-com";
export default {
  name: "BaseContactForm",

  data() {
    return {
      // title: "Conract Form",
      email: "",
      name: "",
      message: "",
      show_contact: true,
      contact_email: "",
      message: "",
      contact_notice: "",
    };
  },

  methods: {
    // async addEmail(email) {
    //   var noticeMessage = "🎉 Your account has been reserved 🎉";
    //   await Auth.createUserWithEmailAndPassword(
    //     email,
    //     this.randomPassword(20)
    //   ).catch(function(error) {
    //     if (error.code != "auth/email-already-in-use") {
    //       noticeMessage = error.message;
    //     }
    //   });
    //   this.message = noticeMessage;
    //   this.email = "";
    // },

    // randomPassword(length) {
    //   var chars =
    //     "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
    //   var password = "";
    //   for (var x = 0; x < length; x++) {
    //     var i = Math.floor(Math.random() * chars.length);
    //     password += chars.charAt(i);
    //   }
    //   return password;
    // },

    sendEmail(e) {
      console.log(e);
      try {
        emailjs.sendForm(
          "service_vpjk74i",
          "template_4yexp3s",
          e.target,
          "user_EDKMuaufVZ6sQ1QChMQAy",
          {
            name: this.name,
            email: this.email,
            message: this.message,
          }
        );
      } catch (error) {
        console.log({ error });
      }
      // Reset form field
      this.name = "";
      this.email = "";
      this.message = "";
      this.show_contact = false;
    },

    // sendEmail: function() {
    //   const callable = functions.httpsCallable("genericEmail");
    //   return callable({
    //     text: "Sending email with Vue and SendGrid is fun!",
    //     subject: "Email from Vue"
    //   }).then(console.log);
    // },

    // sendContactMessage() {
    //   if (!this.validEmail(this.contact_email)) {
    //     this.contact_notice = "The email address is badly formatted.";
    //   } else if (this.contact_message.length < 10) {
    //     this.contact_notice = "Your message is too short";
    //   } else {
    //     const url = `https://us-central1-strapp-4e040.cloudfunctions.net/sendEmail?email_from=${this.contact_email}&message=${this.contact_message}`;
    //     const requestOptions = {
    //       method: "GET",
    //       headers: { "Content-Type": "application/json" }
    //     };
    //     fetch(url, requestOptions);
    //     this.show_contact = false;
    //   }
    // },

    // validEmail(email) {
    //   var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // }
  },

  // Injected from the Vuetify Themeable mixin
  inject: ["theme"],

  props: {
    subtitle: String,
    title: {
      type: String,
      default: "MAIL US YOUR MESSAGE",
    },
  },
};
</script>

<style scoped>
.round {
  border-radius: 8px !important;
}
.hero-button {
  padding: 1rem 4rem;
  border-radius: 100rem;
  color: white;

  width: 10rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.hero-button:hover {
  width: 11rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}
</style>
